import { render } from "./Index.vue?vue&type=template&id=4ebb54d3&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=4ebb54d3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ebb54d3"

export default script